define("settings/components/section/item-wrapper", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAC--section__item" ...attributes>
    {{yield}}
  </div>
  <hr class="tAC--section__divider" />
  */
  {
    "id": "0zYgoa8Q",
    "block": "[[[11,0],[24,0,\"tAC--section__item\"],[17,1],[12],[1,\"\\n  \"],[18,2,null],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13]],[\"&attrs\",\"&default\"],false,[\"yield\"]]",
    "moduleName": "settings/components/section/item-wrapper.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});